import { requestWithToken as request } from "./api";

// Exportaciones a Google Sheets del panel del analista. Los tres POST
// encolan la exportación en RQ y responden 202 `{job_id, job_ids, count,
// message, notice}`; `getSheetExportStatus` sirve el sondeo hasta `finished`
// o `failed` (antes el POST esperaba al Go y el router lo cortaba a los 30 s).
export const downloadObligationsToSheet = (params = {}) =>
    request.post("/download_obligations/?format=json", params);

export const downloadMovementsToSheet = (params = {}) =>
    request.post("/download_movements/?format=json", params);

export const exportClassificationsToSheet = (params = {}) =>
    request.post("/export_classifications/?format=json", params);

export const getSheetExportStatus = (jobId) =>
    request.get(`/sheet_exports/status/?job_id=${encodeURIComponent(jobId)}&format=json`);
